import type {FunctionComponent} from 'react';
import {Image} from '@app/components/Image';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '1b6b5c6de1085a04a6084b979f587f55.png',
	fr: '1c0292c7f3e22e8134362a29beeb81ec.png',
};

export const ShakerImg: FunctionComponent = () => {
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<Image
			alt={'Shaker'}
			objectFit="contain"
			aspectRatio="2880/1012"
			src={src}
		/>
	);
};
